"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject4ToJSON = exports.InlineObject4FromJSONTyped = exports.InlineObject4FromJSON = void 0;
var _1 = require("./");
function InlineObject4FromJSON(json) {
    return InlineObject4FromJSONTyped(json, false);
}
exports.InlineObject4FromJSON = InlineObject4FromJSON;
function InlineObject4FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'event': json['event'],
        'payload': (0, _1.ChowlyWebhookUniversalPayloadFromJSON)(json['payload']),
        'meta': (0, _1.ChowlyWebhookUniversalMetaFromJSON)(json['meta']),
    };
}
exports.InlineObject4FromJSONTyped = InlineObject4FromJSONTyped;
function InlineObject4ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'event': value.event,
        'payload': (0, _1.ChowlyWebhookUniversalPayloadToJSON)(value.payload),
        'meta': (0, _1.ChowlyWebhookUniversalMetaToJSON)(value.meta),
    };
}
exports.InlineObject4ToJSON = InlineObject4ToJSON;
